/* src/tutors/actions.js */

import {
  fetchTutorsTypes,
  fetchTutorTypes,
  setReviewVisibilityTypes,
  addNoteTypes,
  editNoteTypes,
  removeNoteTypes,
  removeTutorTypes,
  CLEAR_SELECTED_TUTOR,
} from './action_types';

import {
  FETCH_TUTORS_QUERY,
  FETCH_TUTOR_QUERY,
  SET_REVIEW_VISIBILITY_MUTATION,
  ADD_NOTE_MUTATION,
  EDIT_NOTE_MUTATION,
  REMOVE_NOTE_MUTATION,
  REMOVE_TUTOR_MUTATION,
} from './api';

import { makeQuery, makeMutation } from '../../config/client';

export const fetchTutors = variables => makeQuery(variables)(
  fetchTutorsTypes,
  FETCH_TUTORS_QUERY
);

export const fetchTutor = variables => makeQuery(variables)(
  fetchTutorTypes,
  FETCH_TUTOR_QUERY
);

export const setReviewVisibility = variables => makeMutation({ variables })(
  setReviewVisibilityTypes,
  SET_REVIEW_VISIBILITY_MUTATION
);

export const addNote = variables => makeMutation({ variables })(
  addNoteTypes,
  ADD_NOTE_MUTATION
);

export const editNote = variables => makeMutation({ variables })(
  editNoteTypes,
  EDIT_NOTE_MUTATION
);

export const removeNote = variables => makeMutation({ variables })(
  removeNoteTypes,
  REMOVE_NOTE_MUTATION
);

export const removeTutor = variables => makeMutation({ variables })(
  removeTutorTypes,
  REMOVE_TUTOR_MUTATION
);

export const clearSelectedTutor = () => ({
  type: CLEAR_SELECTED_TUTOR,
});



// WEBPACK FOOTER //
// ./src/modules/tutors/actions.js